import React from 'react';

import { InstagramIcon } from '@depop/web-ui-kit/Icons/InstagramIcon';
import { TiktokIcon } from '@depop/web-ui-kit/Icons/TiktokIcon';
import { XIcon } from '@depop/web-ui-kit/Icons/XIcon';
import { VisuallyHidden } from '@depop/web-ui-kit/VisuallyHidden';
import { useTranslations } from 'next-intl';

import { SOCIAL_MEDIA_SITES } from '../../constants/externalUrls';

import styles from './styles.module.css';

export function SocialBadges() {
  const t = useTranslations('common');
  return (
    <ul className={styles.socialBadges}>
      <li className={styles.socialListItem}>
        <a
          className={styles.socialLink}
          href={SOCIAL_MEDIA_SITES.X}
          rel="noreferrer"
          target="_blank"
        >
          <VisuallyHidden>{t('SocialMedia.X')}</VisuallyHidden>
          <XIcon color="black" size={24} />
        </a>
      </li>
      <li className={styles.socialListItem}>
        <a
          className={styles.socialLink}
          href={SOCIAL_MEDIA_SITES.INSTAGRAM}
          rel="noreferrer"
          target="_blank"
        >
          <VisuallyHidden>{t('SocialMedia.Instagram')}</VisuallyHidden>
          <InstagramIcon size={24} color="black" />
        </a>
      </li>
      <li className={styles.socialListItem}>
        <a
          className={styles.socialLink}
          href={SOCIAL_MEDIA_SITES.TIKTOK}
          rel="noreferrer"
          target="_blank"
        >
          <VisuallyHidden>{t('SocialMedia.Tiktok')}</VisuallyHidden>
          <TiktokIcon size={24} color="black" />
        </a>
      </li>
    </ul>
  );
}
